import {AiBrain01Icon, LanguageSquareIcon, Mic01Icon, VolumeHighIcon} from "@hugeicons/core-free-icons";

// Model pages, grouped under "Models" in the header and drawer. Transcribe/Voice models are also
// open to the "manager" account role (see canManage in those pages); the rest stay admin-only.
export const MODEL_LINKS = [
    {to: "/ai-models", label: "LLM Models", icon: AiBrain01Icon, adminOnly: true},
    {to: "/transcribe-models", label: "Transcribe Models", icon: Mic01Icon},
    {to: "/voice-models", label: "Synthesize Models", icon: VolumeHighIcon},
    {to: "/languages", label: "Languages", icon: LanguageSquareIcon, adminOnly: true},
];
